<template>
  <div class="my-order">
    <rCenterHeader :list="headerMenu">
      <div slot="search">
        <form>
          <Input
            size="large"
            @on-click="search('')"
            @keydown.enter.native.prevent="search('')"
            v-model="params.keyWord"
            icon="ios-search"
            :placeholder="$t('fabricLibrary.search')"
            style="width: 380px; color: #081938"
          />
          <Button
            @click="filterClick"
            class="filter"
            size="large"
            type="primary"
          >
            <span class="iconfont iconshaixuan"></span>
            {{ $t("fabricLibrary.filter") }}
          </Button>
        </form>
      </div>
    </rCenterHeader>
    <div class="order-list">
      <rOrder
       :index="index"
        @details="details"
        @urgent="urgent"
        @cancel="cancel"
        @changeTip="changeTip"
        @addTip="addTip"
        @delTips="delTips"
        v-for="(item, index) in orderList"
        :key="index"
        :config="item"
      ></rOrder>
      <Spin size="large" fix v-if="spinShow"></Spin>
      <rNull
        v-if="orderList.length == 0 && spinShow == false"
        imgStyle="width:300px;margin:0 auto"
        titleStyle="font-size:16px;color:#999"
        :title="$t('noResult')"
      ></rNull>
    </div>
    <div
      class="common-flex common-justify-center"
      v-if="total"
      style="margin-top: 20px; padding-bottom: 20px"
    >
      <Page
        :total="total"
        @on-change="changePage"
        :page-size="params.pageSize"
        :page-size-opts="[20, 40, 60, 80]"
        show-total
      >
        <span>{{ $t("total") }} {{ total }} {{ $t("recoprds") }}</span>
      </Page>
    </div>
    <!-- 添加备注弹框 -->
    <rEditTipModal
      @updateCart="updateCart"
      :chooseOrderId="chooseOrderId"
      :chooseContent="chooseContent"
      tipType="cart"
      :tipShow="tipShow"
      @handlerTipShow="handlerTipShow"
    ></rEditTipModal>
    <!-- 取消订单弹框 -->
    <rConfirmModal
      @cancel="cancels"
      @confrim="confrim"
      :config="rConfirmModalConfig"
      :cancelShow="cancelShow"
      :spinShow="spinShow"
      @handlerCancelShow="handlerCancelShow"
    ></rConfirmModal>
    <!-- 紧急订单弹框 -->
    <rUrgentModal
      :urgentShow="urgentShow"
      @handlerUrgentShow="handlerUrgentShow"
    ></rUrgentModal>
    <!-- 搜索项 -->
    <rOrderFilter
      filterType="order"
      :params="params"
      @search="search"
      @close="closeFilte"
      :filteShow="filteShow"
    ></rOrderFilter>
    <Modal
      v-model="orderDetails"
      style="height: 90%"
      footer-hide
      fullscreen
      title=""
    >
      <div class="title-box">
        <div class="title">{{ $t("saveItems.CheckOptions") }}</div>
        <div
          @click="closeDetails"
          class="common-hover iconfont iconguanbi"
        ></div>
      </div>
      <rOrderDetails
        :config="orderMsg"
        :hideStep="true"
        detailsType="picture"
      ></rOrderDetails>
    </Modal>
    <!-- <rOrderFilter  @close="closeFilte" :filteShow="filteShow"></rOrderFilter> -->
  </div>
  <!-- </div> -->
</template>

<script>
import rOrder from "../../components/r-order";
import rCenterHeader from "../../components/r-center-header";
import rEditTipModal from "../../components/r-edit-tip-modal";
import rConfirmModal from "../../components/r-confirm-modal";
import rUrgentModal from "../../components/r-urgent-modal";
import rOrderDetails from "../../components/r-order-details";
import rOrderFilter from "../../components/r-order-filter";
import rNull from "../../components/r-null";
import { mapActions } from "vuex";

// r-customer-order
export default {
  name: "my-order",
  data() {
    return {
      total: 0,
      spinShow: false,
      cancelId: "",
      orderDetails: false,
      orderMsg: "",
      params: {
        pageSize: 10,
        pageNum: 1,
        type: 3,
        userId: "", //账号
        status: "", //状态
        start: "", //开始时间
        end: "", //结束时间
        sizeCategoryId: "", //订单尺寸
        clothId: "", //当前选中产品id
        orderType: "", //订单类型
        keyWord: "",
      },
      rConfirmModalConfig: {
        content: this.$t("order.cancelTip"),
        cancel: this.$t("order.cancel"),
        confirm: this.$t("order.confirm"),
      },
      // 总数
      total: 0,
      // 订单列
      orderList: [],
      // 搜索分类显示
      filteShow: false,
      // 取消弹框提示
      cancelShow: false,
      // 编辑tip显示
      tipShow: false,
      // 紧急订单
      urgentShow: false,
      chooseOrderId: "",
      chooseContent: "",
      // 头部面包屑
      headerMenu: [
        {
          name: this.$t("customer.crumbs.myOrder"),
        },
      ],
    };
  },
  components: {
    rOrder,
    rCenterHeader,
    rEditTipModal,
    rConfirmModal,
    rUrgentModal,
    rOrderFilter,
    rOrderDetails,
    rNull,
  },
  mounted() {
    this.getOrderCartList();
  },
  methods: {
    ...mapActions([
      "getOrderCartListAction", //订单列表
      "getCartOrderDetailAction", //订单详情
      "canceMtmOrderAction", //撤销订单
      "saveOrderLabelsAction", //删除tips
    ]),
    // 修改页数
    changePage(e) {
      this.params.pageNum = e;
      this.getOrderCartList();
    },
    // 删除标签
    delTips(labelItem) {
      this.spinShow = true;
      // 从订单的标签列表中删除特定标签
      const orderId = labelItem.orderId;
      const labelIdToRemove = labelItem.id;
      
      // 找到对应的订单
      const order = this.orderList.find(item => item.orderId === orderId);
      if (!order || !order.labels) {
        this.spinShow = false;
        return;
      }
      
      // 过滤出其他标签
      const remainingLabelIds = order.labels
        .filter(label => label.id !== labelIdToRemove)
        .map(label => label.id)
        .join(',');
      
      this.saveOrderLabelsAction({
        orderId: orderId,
        labelIds: remainingLabelIds
      }).then((res) => {
        if (res.code == 0) {
          this.$Message.success('标签已删除');
          this.getOrderCartList();
        } else {
          this.$Message.error(res.message || '删除失败');
        }
      }).finally(() => {
        this.spinShow = false;
      });
    },
    // s更新购物车
    updateCart(isDel) {
      if (!isDel) {
        this.tipShow = false;
      }
      this.params.pageNum = 1;
      this.getOrderCartList();
    },
    // 修改tip
    changeTip(e) {
      this.tipShow = true;
      this.chooseOrderId = e.orderId;
      this.chooseContent = e.labels || [];
    },
    // 修改tip
    addTip(e) {
      this.tipShow = true;
      this.chooseOrderId = e.orderId;
      this.chooseContent = e.labels || [];
    },
    // 隐藏订单列表 操作
    closeDetails() {
      this.orderDetails = false;
    },
    // 搜索
    search(e) {
      if (e) {
        this.params = e;
      }
      this.params.pageNum == 1;
      this.closeFilte();
      this.getOrderCartList();
    },
    // 获得订单列表
    getOrderCartList() {
      let that = this;
      this.spinShow = true;

      this.getOrderCartListAction(this.params)
        .then((res) => {
          this.orderList = res.data;
          this.total = res.total;
        })
        .finally(function () {
          that.spinShow = false;
        });
    },
    // 跳转订单详情
    details(e) {
      // this.$router.push("./orderDetails");
      console.log("e", e);
      this.orderDetails = true;
      this.getCartOrderDetailAction({
        orderId: e.orderId,
      }).then((res) => {
        console.log("res", res);
        this.orderMsg = res.data;
      });
    },
    // 显示搜搜分类
    filterClick() {
      this.filteShow = true;
    },
    confrim(e) {
      this.spinShow = true
      this.canceMtmOrderAction({
        orderId: this.cancelId,
      }).then((res) => {
        if (res.code == 0) {
          // this.params.pageNum = 1;
          this.orderList = [];
          this.getOrderCartList();
        }else{
          this.$Message.error(res.message)
        }
      }).finally(res=>{
      this.spinShow = false
          this.cancelShow = false;

      })
    },
    // 关闭搜索分类
    closeFilte() {
      this.filteShow = false;
    },
    //   修改tip
    // changeTip() {
    //   this.tipShow = true;
    // },
    //   隐藏tip
    handlerTipShow() {
      this.tipShow = false;
    },
    //   取消弹框显示
    cancel(e) {
      this.cancelShow = true;
      this.cancelId = e.orderId;
    },
    cancels(){

    },
    //   隐藏取消弹框
    handlerCancelShow() {
      this.cancelShow = false;
    },
    //   紧急订单弹框显示
    urgent() {
      this.urgentShow = true;
    },
    //   隐藏紧急订单弹框
    handlerUrgentShow() {
      this.urgentShow = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-icon-ios-close {
  display: none;
}
/deep/.ivu-modal-body {
  padding: 0;
}
.title-box {
  height: 84px;
  text-align: center;
  font-size: 20px;
  font-family: Roboto;
  font-weight: 600;
  color: #081938;
  line-height: 84px;
  letter-spacing: 2px;
  // line-height: 84px;
  border-bottom: 1px solid #e6e8eb;
  position: relative;
  .iconguanbi {
    width: 84px;
    height: 84px;
    text-align: center;
    line-height: 84px;
    font-size: 14px;
    color: #081938;
    position: absolute;
    right: 0;
    top: 0;
    border-left: 1px solid #e6e8eb;
  }
}
.my-order {
  font-family: Roboto;
  .filter {
    background: #f8f8f8;
    border: none;
    color: #081938;
    margin-left: 5px;
    width: 85px;
    font-size: 14px;
  }
  .order-list {
    width: 1420px;
    min-height: 100vh;
    margin: 0 auto 20px;
    background: #fff;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/shippedOrders/shippedOrders.vue